<template>
  <div class="profile-page">
    <header class="profile-header">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ section.title }}</span>
    </header>

    <main class="profile-main">
      <section class="profile-hero">
        <div class="profile-number">{{ section.number }}</div>
        <div>
          <p>{{ section.english }}</p>
          <h1>{{ section.title }}</h1>
          <div class="profile-line"></div>
        </div>
      </section>

      <p class="profile-lead">{{ section.lead }}</p>

      <section
        v-for="block in section.blocks"
        :key="block.title"
        class="profile-block"
      >
        <div class="profile-block-title">
          <span></span>
          <h2>{{ block.title }}</h2>
        </div>
        <p v-if="block.content" class="profile-text">{{ block.content }}</p>
        <div v-if="block.items" class="profile-items">
          <article v-for="item in block.items" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </article>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";

const SECTIONS = {
  company: {
    number: "01",
    english: "ABOUT US",
    title: "公司简介",
    lead:
      "ASM太平洋科技有限公司（ASMPT）于1975年在香港成立，是全球领先的半导体和电子制造硬件与软件集成解决方案供应商。1989年在香港联交所上市（股票代码：0522.HK），公司致力于「赋能数字世界」，为全球客户提供从半导体封装材料到后段芯片集成、焊接、封装再到SMT工艺的全流程技术与设备解决方案。",
    blocks: [
      {
        title: "我们的愿景",
        content:
          "成为全球半导体和电子制造领域最具创新力与值得信赖的合作伙伴。以技术为根、品质为本、创新为翼，为全球客户提供从芯片互连载体到智能工厂的全流程集成解决方案，赋能数字世界的可持续发展。"
      },
      {
        title: "集团架构",
        items: [
          {
            title: "半导体解决方案（SEMI）",
            content: "提供先进封装、晶圆级封装、热压键合（TCB）、混合键合、激光划片等技术与设备，服务于AI芯片、高性能计算、存储（HBM）等前沿市场。"
          },
          {
            title: "SMT解决方案",
            content: "提供表面贴装技术（SMT）设备，包括高速贴片机（SIPLACE V平台）、高精度印刷机（DEK TQ XL）、智能工厂软件及自动化解决方案。"
          },
          {
            title: "关键制造（Critical Manufacturing）",
            content: "提供现代化的制造执行系统（MES），助力全球电子制造企业实现工业4.0与智能工厂转型。"
          },
          {
            title: "半导体材料",
            content: "通过合资企业（如与九江合作）发展半导体材料业务，提供蚀刻式及冲压式引线框架等关键封装材料。"
          }
        ]
      },
      {
        title: "发展历程",
        items: [
          { title: "1975 · 公司成立", content: "ASM太平洋科技有限公司在香港成立，作为荷兰ASM International的亚洲营销部门。" },
          { title: "1989 · 香港上市", content: "在香港联交所主板上市，股票代码0522.HK，开启资本市场新征程。" },
          { title: "2002 · 全球第一", content: "成为全球排名第一的半导体组装与封装设备制造商。" },
          { title: "2011 · 战略收购", content: "收购德国西门子旗下SIPLACE业务，进军SMT领域；新加坡成为全球总部。" },
          { title: "2018 · 多元布局", content: "先后收购NEXX（沉积技术）、AMICRA（超高精度贴片）、Critical Manufacturing（MES），构建全产业链能力。" },
          { title: "2025 · 五十周年", content: "庆祝成立50周年，发布50周年纪念电子书，持续引领全球半导体与电子制造技术创新。" }
        ]
      },
      {
        title: "全球总部",
        content: "香港 · 新加坡（全球运营总部）| 在全球设有多个研发中心、生产基地和客户倡导中心，覆盖亚洲、欧洲与美洲。"
      }
    ],
  },
  culture: {
    number: "02",
    english: "CORPORATE CULTURE",
    title: "企业文化",
    lead:
      "以技术创新驱动产业进步，以品质承诺赢得客户信赖。我们坚持长期主义，以客户需求为导向，在全球化协作中持续突破，为半导体与电子制造行业创造可持续价值。",
    blocks: [
      {
        title: "核心价值观",
        items: [
          { title: "技术为根", content: "以持续研发投入和技术创新为核心驱动力，保持全球领先的工程能力。" },
          { title: "品质为本", content: "恪守最高质量标准，坚持精益制造与全流程品质管控。" },
          { title: "创新为翼", content: "以全球视野整合前沿技术，持续优化半导体与SMT解决方案。" },
          { title: "客户至上", content: "深入理解客户需求，提供定制化、端到端的集成解决方案。" },
          { title: "长期主义", content: "不追逐短期利益，致力于与客户、合作伙伴共同实现可持续增长。" },
          { title: "全球协作", content: "依托全球研发与生产网络，以跨文化团队协作应对市场变化。" }
        ]
      },
      {
        title: "团队精神",
        content:
          "全球团队汇聚来自半导体、电子制造、软件工程等领域的顶尖人才，研发人员占比超过30%。团队兼具全球化视野与本土化深耕能力，以专业判断、技术创新和稳定交付服务全球客户。"
      },
      {
        title: "共同使命",
        content:
          "赋能数字世界（Enabling the digital world）——通过提供全面的集成解决方案，为全球客户打造智能工厂，创造并塑造一个光明、可持续的未来，惠及客户、员工、投资者、合作伙伴及社会。"
      }
    ],
  },
  project: {
    number: "03",
    english: "BUSINESS OVERVIEW",
    title: "业务介绍",
    lead:
      "ASMPT是全球唯一一家提供涵盖芯片互连载体、芯片组装与封装到SMT贴装全流程集成解决方案的公司，服务于通信、IT、智能汽车、电动出行、医疗技术、消费电子及工业电子等领域。",
    blocks: [
      {
        title: "半导体解决方案",
        content:
          "提供先进封装（Advanced Packaging）、晶圆级封装、热压键合（TCB）、混合键合（Hybrid Bonding）、激光划片（Laser Singulation）等核心技术与设备，广泛应用于AI芯片、高性能计算（HPC）、高带宽存储（HBM）及3D-IC异构集成等前沿领域。"
      },
      {
        title: "SMT解决方案",
        content:
          "提供SIPLACE V新一代高速贴片平台、DEK TQ XL大尺寸高精度印刷机、物料管理4.0、数据驱动质量分析等产品与方案，覆盖从高精度印刷到高速贴装的全流程SMT制造需求，助力智能工厂建设。"
      },
      {
        title: "关键制造MES",
        content:
          "通过全资子公司Critical Manufacturing提供现代化的制造执行系统（MES），为半导体和电子制造企业提供工业4.0转型所需的智能制造软件平台，实现生产过程全透明化与数据驱动决策。"
      },
      {
        title: "创新技术前沿",
        content:
          "持续投入共封装光学（Co-Packaged Optics）、微转印技术（MTP）、多芯片键合（Multi-Chip Bonding）等前沿技术研发，并与行业及学术领袖组成技术咨询委员会（TAC），加速AI时代的封装技术创新。"
      }
    ],
  }
};

export default {
  name: "CompanyProfile",
  components: { Icon },
  data() {
    return { };
  },
  computed: {
    section() {
      return SECTIONS[this.$route.params.section] || SECTIONS.company;
    }
  },
  watch: {
    section: {
      immediate: true,
      handler(value) {
        if (value && typeof document !== "undefined") {
          document.title = value.title;
        }
      }
    }
  }
};
</script>

<style scoped>
.profile-page {
  min-height: 100vh;
  color: #253342;
  background: #f5f7fa;
}
.profile-header {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  font-size: 17px;
  font-weight: 600;
  color: #172536;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #edf0f3;
}
.profile-header i {
  position: absolute;
  left: 15px;
  font-size: 24px;
}
.profile-main {
  padding: 64px 14px 72px;
}
.profile-hero {
  display: flex;
  align-items: center;
  min-height: 138px;
  padding: 22px 20px;
  color: #fff;
  border-radius: 14px;
  background: linear-gradient(135deg, #092d4e 0%, #086d78 58%, #c69a3b 100%);
  box-shadow: 0 14px 28px rgba(19, 52, 76, 0.19);
}
.profile-number {
  margin-right: 18px;
  font-family: Georgia, serif;
  font-size: 54px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.24);
}
.profile-hero p {
  margin-bottom: 5px;
  font-size: 10px;
  letter-spacing: 2px;
  color: #e4c879;
}
.profile-hero h1 {
  font-size: 25px;
  line-height: 1.3;
}
.profile-line {
  width: 40px;
  height: 3px;
  margin-top: 12px;
  background: #d8b34e;
}
.profile-lead {
  padding: 20px 5px 5px;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  color: #536171;
}
.profile-block,
.profile-source {
  margin-top: 14px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(37, 53, 68, 0.05);
}
.profile-block-title {
  display: flex;
  align-items: center;
  margin-bottom: 13px;
}
.profile-block-title > span {
  width: 4px;
  height: 18px;
  margin-right: 9px;
  border-radius: 2px;
  background: #c8a348;
}
.profile-block-title h2 {
  font-size: 17px;
  font-weight: 600;
  color: #1f3143;
}
.profile-text,
.profile-items p {
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
  color: #657281;
}
.profile-items article {
  padding: 13px 0;
  border-top: 1px solid #eef1f4;
}
.profile-items article:first-child {
  padding-top: 2px;
  border-top: 0;
}
.profile-items article:last-child {
  padding-bottom: 0;
}
.profile-items h3 {
  margin-bottom: 5px;
  font-size: 15px;
  font-weight: 600;
  color: #283d50;
}
</style>
